import { sendRequestProtocols } from "../axios";

export default {
  state: {
    unsubsribes: [],
  },
  mutations: {
    setUnsubsribes(state, payload) {
      state.unsubsribes = payload;
    },
  },
  actions: {
    async GET_UNSUBSCRIBES({ commit }) {
      const { data } = await sendRequestProtocols("unsubscribe", "get");
      commit("setUnsubsribes", data);
    },
  },
  getters: {
    getUnsubscribes: (state) => state.unsubsribes,
  },
};
